const { log } = console


module.exports = function store (state, emitter) {
  emitter.on('toggle-mute', () => {
    if (state.masterVolume === 0) {
      state.masterVolume = state.unmuteVolume
    } else {
      state.unmuteVolume = state.masterVolume
      state.masterVolume = 0
    }
    const node = state.vm.runtime.audioEngine.getInputNode()
    const volPercent = state.masterVolume / 100
    const gain = volPercent * volPercent
    node.gain.setValueAtTime(gain, 0)
    emitter.emit('render')
  })

  emitter.on('toggle-main-menu', () => {
    log('toggle-main-menu')
    if (state.glitchEditorOpen) {
      emitter.emit('close-glitch-editor')
    }
    state.isInventoryOpen = false
    state.isMenuOpen = !state.isMenuOpen
    if (state.isMenuOpen) {
      if (!state.wasGamePlaying) {
        state.wasGamePlaying = state.isGamePlaying
      }
      emitter.emit('pause')
    } else {
      emitter.emit('close-menu')
    }
    emitter.emit('render')
  })

  emitter.on('set-volume', value => {
    log('set-volume', value)
    state.masterVolume = value
    emitter.emit('render')
  })

  emitter.on('reset-game', () => {
    log('reset-game')
    window.location.reload()
  })

  emitter.on('back-to-browser', () => {
    log('back-to-browser')
    window.location.assign('/')
  })


  emitter.on('close-menu', () => {
    log('close-menu')
    state.isMenuOpen = false
    if (state.wasGamePlaying) {
      emitter.emit('play')
    }
    emitter.emit('render')
  })
}
